import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import {
  AttributeItemModel,
  ImageModel,
  OpportunityModel,
} from "../../../models";
import { ModelId } from "../../../../defines";
import { JsonApiManyResponse, ModelScope } from "../../../types";

export default function apiOpportunityModel(
  opts: ApiModelOptions<OpportunityModel>,
) {
  const model = ApiModel<OpportunityModel>("opportunity", {
    usePlacement: true,
    urls: {
      [ModelScope.Manager]: {
        getMany: "/manager/opportunities",
      },
    },
    ...opts,
  });

  const updateAttributes = async (
    id: ModelId,
    attributes: AttributeItemModel[],
  ) => {
    const attributesToSave = attributes.map((attr) => ({
      attribute_id: attr.id,
      is_primary_strategy: attr.isPrimaryStrategy,
      is_primary_property_type: attr.isPrimaryPropertyType,
    }));

    return await model.apiClient.rpcRequest("update-opportunity-attributes", {
      opportunity_id: parseInt(String(id)),
      attributes: attributesToSave,
    });
  };

  const getImages = async (idOpportunity: ModelId) => {
    const result = await model.apiClient.apiRequest<
      JsonApiManyResponse<ImageModel>
    >(`/images/opportunity/${idOpportunity}`);

    return result.data || [];
  };

  return { ...model, updateAttributes, getImages };
}
